/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import PreviewExpand from '@prospectus/common/ui/PreviewExpand';

function MainFAQ({
  faq,
  intl,
  commonMessages,
  refProp,
  mobile,
}) {
  const messages = defineMessages(
    {
      'prospectus.course.detail.faq': {
        id: 'prospectus.course.detail.faq',
        description: 'Header text for FAQs',
        defaultMessage: 'Frequently Asked Questions',
      },
    },
  );

  if (mobile) {
    return (
      <div className="html-data" dangerouslySetInnerHTML={{ __html: faq }} />
    );
  }
  return (
    <PreviewExpand
      cta={
        {
          labelToExpand: intl.formatMessage(commonMessages.showMore),
          labelToMinimize: intl.formatMessage(commonMessages.showLess),
          id: 'faq',
          className: 'btn btn-link mt-2 pt-1 pt-sm-2 px-0 pb-0',
        }
      }
      heading={(
        <h1 className="pt-3 mt-3 pt-sm-5 mt-sm-2 nav-target" ref={refProp}>
          {intl.formatMessage(messages['prospectus.course.detail.faq'])}
        </h1>
      )}
      sectionTitle={intl.formatMessage(messages['prospectus.course.detail.faq'])}
      excludeIcon
      innerClassName="m-0"
    >
      <div className="mt-2 html-data" dangerouslySetInnerHTML={{ __html: faq }} />
    </PreviewExpand>
  );
}

MainFAQ.propTypes = {
  faq: PropTypes.string,
  intl: intlShape.isRequired,
  commonMessages: PropTypes.shape({
    showMore: PropTypes.shape({}).isRequired,
    showLess: PropTypes.shape({}).isRequired,
  }).isRequired,
  refProp: PropTypes.shape().isRequired,
  mobile: PropTypes.bool,
};

MainFAQ.defaultProps = {
  faq: null,
  mobile: false,
};

export default injectIntl(MainFAQ);
